import React from "react";
import InputTooltip, { placement } from "@/components/general/tooltip";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import useMediaQuery from "@mui/material/useMediaQuery";
import styles from "@/components/forms/inputsWithRef/radioButtonsWithRef.module.css";

interface Props {
  onChange?: (target: any) => void;
  name?: string;
  choices?: any;
  required?: boolean;
  mandatory?: boolean;
  label?: string;
  defaultValue?: any;
  readonly?: boolean;
  boolOption?: boolean;
  tooltip?: boolean;
  placement?: placement;
  tooltipMessage?: any;
  labelRightSlot?: React.ReactNode;
}

export const RadioButtonsWithRef = React.forwardRef<HTMLInputElement, Props>(
  function RadioButtonsWithRef(props, ref) {
    const theme = useTheme();
    const { t } = useTranslation();
    let items: any = [];
    const itemsRendered = [];

    if (props.choices !== undefined) {
      if (Object.keys(props.choices).length > 0) {
        items = props.choices;
      }
    } else if (Object.prototype.hasOwnProperty.call(props, "boolOption")) {
      items.push({ name: "yes", label: t("yes") });
      items.push({ name: "no", label: t("no") });
      items.push({ name: "noStatement", label: t("noStatement") });
    } else {
      items.push({ name: "yes", label: t("yes") });
      items.push({ name: "no", label: t("no") });
    }
    const normalizeDefaultValue = (defaultValue: any) => {
      if (defaultValue === true) return "yes";
      if (defaultValue === false) return "no";
      return defaultValue;
    };
    const defaultValueMapped = normalizeDefaultValue(props.defaultValue);

    for (const key in items) {
      itemsRendered.push(
        <React.Fragment key={items[key].name}>
          <label
            htmlFor={props.name + items[key].name}
            className={styles.radioLabel}
          >
            <input
              ref={ref}
              type="radio"
              id={props.name + items[key].name}
              value={items[key].name}
              disabled={props.readonly}
              readOnly={props.readonly}
              name={props.name}
              required={props.required}
              onChange={props.onChange}
              defaultChecked={items[key].name === defaultValueMapped}
              // checked={items[key].name === defaultValueMapped}
              className={styles.radioButtonInput}
            />
            <span className={styles.customRadioButton}>{items[key].label}</span>
          </label>
        </React.Fragment>
      );
    }

    return (
      <div>
        <div className={styles.radioGroupLabel}>
          <span className={styles.labelText} role="presentation">
            {props.label}
            {(props.mandatory === true || props.required === true) && (
              <span className={styles.labelRequired}>*</span>
            )}
            {props.tooltip && (
              <InputTooltip
                tooltipMessage={props.tooltipMessage}
                placement={props.placement}
              />
            )}
          </span>
          {props.labelRightSlot && (
            <span className={styles.labelRightSlot}>{props.labelRightSlot}</span>
          )}
        </div>
        <div
          className={
            props.boolOption
              ? styles.radioButtonWrapperThirdOption
              : styles.radioButtonWrapper
          }
          style={{
            gridTemplateColumns: useMediaQuery(theme.breakpoints.up("sm"))
              ? "1fr 1fr 1fr"
              : "1fr",
          }}
        >
          {itemsRendered}
        </div>
      </div>
    );
  }
);
